import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=a0a8123e&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"
import style0 from "./footer-primary.vue?vue&type=style&index=0&id=a0a8123e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a8123e",
  null
  
)

export default component.exports